import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Modal,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import axios from "axios";
import TPC_URL from "../../../utils/TPC_URL";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 2,
  p: 4,
};

const buttonStyle = {
  mt: 3,
  display: "flex",
  justifyContent: "flex-end",
  gap: 2,
};

function LotSettingModal({ open, handleClose, group_code, project_code }) {
  const [lotValue, setLotValue] = useState("100");
  const [isLoading, setIsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState(null);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  useEffect(() => {
    if (open) {
      fetchLotSize();
    }
  }, [open]);
  const fetchLotSize = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get(
        TPC_URL +
          `/api/tpc/getLot?group_code=${group_code}&project_code=${project_code}`
      );
      setLotValue(response.data || "100");
    } catch (error) {
      setError("LOT 설정을 불러오는 중 오류가 발생했습니다.");
      setLotValue("100");
    } finally {
      setIsLoading(false);
    }
  };
  const handleInputChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    setLotValue(value);
  };
  const handleSave = async () => {
    setIsSaving(true);
    try {
      await axios.post(TPC_URL + `/api/tpc/updateLot`, {
        group_code,
        project_code,
        size: lotValue,
      });
      setSnackbar({
        open: true,
        message: "LOT 설정이 성공적으로 업데이트되었습니다.",
        severity: "success",
      });
      setTimeout(() => {
        handleClose();
      }, 200);
    } catch (error) {
      console.error("LOT 설정 업데이트 오류:", error);
      setSnackbar({
        open: true,
        message: "LOT 설정 업데이트 중 오류가 발생했습니다.",
        severity: "error",
      });
    } finally {
      setIsSaving(false);
    }
  };
  const handleCloseSnackbar = () => {
    setSnackbar({
      ...snackbar,
      open: false,
    });
  };
  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="lot-setting-modal-title"
      >
        <Box sx={style}>
          <Typography
            id="lot-setting-modal-title"
            variant="h6"
            component="h2"
            mb={3}
          >
            LOT 설정
          </Typography>
          {isLoading ? (
            <Box sx={{ display: "flex", justifyContent: "center", my: 4 }}>
              <CircularProgress />
            </Box>
          ) : error ? (
            <Typography color="error" sx={{ mb: 2 }}>
              {error}
            </Typography>
          ) : (
            <TextField
              fullWidth
              label="LOT 크기"
              variant="outlined"
              value={lotValue}
              onChange={handleInputChange}
              InputProps={{
                inputProps: {
                  inputMode: "numeric",
                  pattern: "[0-9]*",
                },
              }}
              helperText="숫자만 입력 가능합니다"
            />
          )}
          <Box sx={buttonStyle}>
            <Button
              variant="outlined"
              onClick={handleClose}
              disabled={isSaving}
            >
              취소
            </Button>
            <Button
              variant="contained"
              onClick={handleSave}
              disabled={isLoading || isSaving}
            >
              {isSaving ? (
                <>
                  <CircularProgress size={20} sx={{ mr: 1 }} color="inherit" />
                  저장 중...
                </>
              ) : (
                "수정"
              )}
            </Button>
          </Box>
        </Box>
      </Modal>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}

export default LotSettingModal;
